import { makeObservable } from 'mobx';

import { Filtro } from './Filtro';

export default class FiltroAnotacoesCurtas extends Filtro {
    static LABEL_VALOR_VAZIO = '----- VAZIO OU EM BRANCO -----';

    tipo = 'selecao';

    exibicao = 'select';

    selecaoMultipla = true;

    constructor(props) {
        super(props);
        makeObservable(this, {
            tipo: true,
            exibicao: true,
            selecaoMultipla: true,
            label: true,
            getValorOpcao: true,
            equals: true,
            getDescricao: true
        });
    }

    get label() {
        return 'Anotações curtas';
    }

    getValorOpcao(registro) {
        return registro.informacaoProcessoSalaSessao?.anotacao?.trim() || FiltroAnotacoesCurtas.LABEL_VALOR_VAZIO;
    }

    equals(valor1, valor2) {
        return valor1?.trim() === valor2?.trim();
    }

    getDescricao(valor) {
        return valor || FiltroAnotacoesCurtas.LABEL_VALOR_VAZIO;
    }
}
